import { createSelector } from '@reduxjs/toolkit';
import { ResultMethodsListState } from 'ducks/result-methods-list/slices';
import { RootState } from 'store';

const resultMethodsListSlice = (state: RootState) => state.result_methods_list;

export const selectResultMethodsList = createSelector(
  [resultMethodsListSlice],
  (state): ResultMethodsListState => state,
);
